import classNames from "classnames";
import React from "react";
import progress1 from "src/images/progress-bar/1.png";
import progress2 from "src/images/progress-bar/2.png";
import progress3 from "src/images/progress-bar/3.png";
import progress4 from "src/images/progress-bar/4.png";

interface Step {
  label: string;
  image: string;
  title?: string;
  className?: string;
}

const steps: Step[] = [
  {
    label: "Empty cart",
    image: progress1,
    className: "adjusted-image",
    title: "Free Joint Treats",
  },
  {
    label: "Free shipping",
    image: progress2,
    className: "adjusted-image2",
    title: "Free Calming Blanket",
  },
  {
    label: "Free Calming Blanket",
    image: progress3,
    title: "Free Calming Bed",
    className: "adjusted-image3",
  },
  {
    label: "Free Calming Bed",
    image: progress4,
    className: "adjusted-image4",
  },
];

interface ProgressBarClasses {
  root?: string;
  title?: string;
  slider?: string;
  image?: string;
}

interface ProgressBarProps {
  currentStep: number;
  remainingAmount: number;
  classes?: ProgressBarClasses;
}

const ProgressBar: React.FC<ProgressBarProps> = ({
  currentStep,
  remainingAmount,
  classes = {},
}) => {
  const currentTitle = steps[currentStep]?.title;

  return (
    <div
      className={classNames("progress-container", classes.root)}
      role="progressbar"
      aria-valuenow={currentStep}
    >
      {currentTitle && (
        <div className={classNames("progress-title", classes.title)}>
          <p>{`You're $${remainingAmount} away from`}</p>
          <span>{currentTitle}</span>
        </div>
      )}

      <div
        className={classNames(
          "image-slider",
          { "adjusted-image-slider": currentStep === 3 },
          classes.slider
        )}
      >
        {steps.map((step, index) => (
          <img
            key={index}
            src={step.image}
            alt={step.label}
            className={classNames(
              "step-image",
              index === currentStep && "visible",
              step.className,
              classes.image
            )}
          />
        ))}
      </div>
    </div>
  );
};

export default ProgressBar;
